// 提示信息弹框
export default {
  methods: {
    showAlert(message, type = 'warning', confirmText = '确定') {
      this.$swal({
        type,
        text: message,
        confirmButtonText: confirmText,
      });
    },
  },
};


// WEBPACK FOOTER //
// ./src/common/alertTrends.js